var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "@wordpress/element";
import { DELETE_CUSTOM_FIELD } from "../../../../../constants";
import { useCustomFieldActions } from "../../../../../hooks/actions/useCustomFieldActions";
import { CustomFieldsContext } from "../../../../../providers/CustomFieldsContextProvider";
import { CustomFieldEntityType, CustomFieldType, } from "../../../../../types/custom-field";
import { WPQTInput } from "../../../../common/Input/Input";
import { CustomFieldActions } from "../CustomFieldActions/CustomFieldActions";
function CustomField({ data }) {
    const [value, setValue] = useState("");
    const { state: { entityType, entityId }, customFieldsDispatch, } = useContext(CustomFieldsContext);
    const { updateCustomFieldValue, markCustomFieldAsDeleted } = useCustomFieldActions();
    const [actionLoading, setActionLoading] = useState(false);
    useEffect(() => {
        if (data.value) {
            setValue(data.value);
        }
    }, [data.value]);
    const handleSave = () => __awaiter(this, void 0, void 0, function* () {
        if (entityType === CustomFieldEntityType.User ||
            entityType === CustomFieldEntityType.Task) {
            setActionLoading(true);
            yield updateCustomFieldValue(data.id, value, entityId, entityType);
            setActionLoading(false);
        }
        else {
            console.error("Invalid entity type for saving custom field value");
        }
    });
    const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
        setActionLoading(true);
        yield markCustomFieldAsDeleted(data.id, () => {
            customFieldsDispatch({ type: DELETE_CUSTOM_FIELD, payload: data.id });
        });
        setActionLoading(false);
    });
    let customFieldElement;
    switch (data.type) {
        case CustomFieldType.Text: {
            customFieldElement = (_jsx(TextCustomField, { data: data, value: value, onChange: setValue }));
            break;
        }
        case CustomFieldType.Checkbox: {
            customFieldElement = (_jsx(CheckboxCustomField, { data: data, value: value, onChange: setValue }));
            break;
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", {}), customFieldElement, _jsx(CustomFieldActions, { data: data, locationOfCustomFields: entityType, onSave: handleSave, onDelete: handleDelete, actionLoading: actionLoading })] }));
}
function TextCustomField({ data, value, onChange }) {
    return (_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-justify-center", children: [_jsx(CustomFieldTitle, { name: data.name, description: data.description }), _jsx(WPQTInput, { value: value, onChange: onChange })] }));
}
function CheckboxCustomField({ data, value, onChange, }) {
    return (_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center", children: [_jsx(CustomFieldTitle, { name: data.name, description: data.description }), _jsx("input", { type: "checkbox", checked: value === "true", className: "!wpqt-block", onChange: (e) => onChange(e.target.checked ? "true" : "false") })] }));
}
function CustomFieldTitle({ name, description = "" }) {
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "wpqt-mb-1 wpqt-text-base wpqt-font-semibold", children: name }), description && (_jsx("div", { className: "wpqt-mb-2 wpqt-italic", children: description }))] }));
}
export { CustomField, CustomFieldTitle };
